import API from 'services/API';
import { moment } from 'utils';

const ACCOUNT_TYPE_MAP = {
  1: 'Общий (совместный) счет',
};

export default function getAccountsAbroad() {
  return API.request({
    method: 'GET',
    url: '/foreignBankAccount/all',
    mapper: (data = []) => {
      return data
        .map((account) => {
          return Object.assign({}, account, {
            openDate: account.openDate ? moment.fromServerDatetime(account.openDate) : null,
            closeDate: account.closeDate ? moment.fromServerDatetime(account.closeDate) : null,
            accountContractDate: account.accountContractDate
              ? moment.fromServerDatetime(account.accountContractDate)
              : null,
            resolutionDate: account.resolutionDate
              ? moment.fromServerDatetime(account.resolutionDate)
              : null,
            permissionDate: account.permissionDate
              ? moment.fromServerDatetime(account.permissionDate)
              : null,
            recordCreateDate: account.recordCreateDate
              ? moment.fromServerDatetime(account.recordCreateDate)
              : null,
            recordUpdateDate: account.recordUpdateDate
              ? moment.fromServerDatetime(account.recordUpdateDate)
              : null,
            bankDataUpdateDate: account.bankDataUpdateDate
              ? moment.fromServerDatetime(account.bankDataUpdateDate)
              : null,
            countryCode: account.countryCode ? `${account.countryCode}` : null,
            openNotificationDate: account.openNotificationDate
              ? moment.fromServerDatetime(account.openNotificationDate)
              : null,
            closeNotificationDate: account.closeNotificationDate
              ? moment.fromServerDatetime(account.closeNotificationDate)
              : null,
            updateNotificationDate: account.updateNotificationDate
              ? moment.fromServerDatetime(account.updateNotificationDate)
              : null,
            accountNumberChangeDate: account.accountNumberChangeDate
              ? moment.fromServerDatetime(account.accountNumberChangeDate)
              : null,
            accountType: ACCOUNT_TYPE_MAP[account.bankAccountId],
            bankAccountTypeId: account.bankAccountTypeId,
            bankAccountId: account.bankAccountId,
            coownersNumber: account.coownersNumber,
            accountTypeCode: account.accountTypeCode ? `${account.accountTypeCode}` : null,
            digitalCode: account.okv ? `${account.okv}` : null,
            financialOrganizationSign: account.financialOrganizationSign
              ? `${account.financialOrganizationSign}`
              : null,
            accountSign: account.accountSign ? `${account.accountSign}` : null,
          });
        })
        .sort((account1, account2) => {
          if (!account1.closed && account2.closed) {
            return -1;
          } else if (account1.closed && !account2.closed) {
            return 1;
          }
          const pseudonym1 = account1.pseudonym || '';
          const pseudonym2 = account2.pseudonym || '';

          return pseudonym1.localeCompare(pseudonym2, 'eng');
        });
    },
  });
}
